var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEye = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#A1AEB7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.935 5.747C17.853 2.224 14.073.017 10 .017S2.143 2.223.065 5.746a.383.383 0 0 0 0 .424C2.147 9.694 5.927 11.902 10 11.902s7.857-2.208 9.935-5.73a.383.383 0 0 0 0-.425zM10 11.053A10.617 10.617 0 0 1 .955 5.96 10.617 10.617 0 0 1 10 .865c3.694 0 7.135 1.951 9.045 5.094A10.617 10.617 0 0 1 10 11.053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2.139a3.805 3.805 0 0 0-3.82 3.82A3.805 3.805 0 0 0 10 9.78a3.805 3.805 0 0 0 3.82-3.82A3.805 3.805 0 0 0 10 2.14zm0 6.792a2.954 2.954 0 0 1-2.971-2.972A2.956 2.956 0 0 1 10 2.988a2.956 2.956 0 0 1 2.971 2.971A2.954 2.954 0 0 1 10 8.931z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.261v.85c.465 0 .849.383.849.848a.854.854 0 0 1-.849.85.854.854 0 0 1-.849-.85h-.849c0 .935.763 1.698 1.698 1.698.935 0 1.698-.763 1.698-1.698 0-.935-.763-1.698-1.698-1.698z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye.8d00b0ed.svg";
export { ForwardRef as ReactComponent };